import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { getTopStocks } from '../actions/topStocks';
import TopStocksPage from '../components/TopStocks';

type AppDispatch = ThunkDispatch<RootReducerState, unknown, TopStocksAction>;

interface MapStateToProps {
  topStocks?: TopStocksContent
}

const mapStateToProps = (state: RootReducerState): MapStateToProps => {
  return {
    topStocks: state.topStocks.content
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: AppDispatch) => ({
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getTopStocks: () => dispatch(getTopStocks())
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type TopStocksProps = ConnectedProps<typeof connector>;
export default connector(TopStocksPage);
